export default "__VITE_ASSET__CnSJK0Hv__"